import { TieringDetailsModalModalComponent } from 'pages/Settings/modals/ShiftDistributionRulesTieringModal/ShiftDistributionRulesTieringModal.component';
import { TieringDetailsViewUIProvider } from 'pages/Settings/modals/ShiftDistributionRulesTieringModal/ShiftDistributionRulesTieringModal.ui.context';
import { FC } from 'react';

export const ShiftDistributionRulesTieringModal: FC = () => {
  return (
    <TieringDetailsViewUIProvider>
      <TieringDetailsModalModalComponent />
    </TieringDetailsViewUIProvider>
  );
};
